import React from 'react';
import PropTypes from 'prop-types';

const Link = ({ data }) => {
	return (
		<a className="footer-links" href={ data.linkUrl } title={ data.linkText } aria-label ={ `${data.linkText} opens in new window` } rel="noopener noreferrer" target="_blank">
			{ data.linkText }
		</a>
	);
};

export default function FooterLinks({ links }) {
	return (
		<div className="footer-links-container">
			{
				links.map(link => {
					return <Link href= ' ' key={ link.id } data={ link } />
				})
			}
		</div>
	);
}

FooterLinks.propTypes = {
	links: PropTypes.arrayOf(PropTypes.object).isRequired,
};
